// extracted by mini-css-extract-plugin
export default {"button":"buttom_button__Y24jx"};